export const LineTemplate = `
const [categoryLabel, seriesLabel] = header;
const [category, series] = data;

const option = {
    tooltip: {
        trigger: 'axis',
        confine: false,
    },
    grid: {
        top: 5,
        left: 5,
        right: 5,
        bottom: 5,
        containLabel: true
    },
    xAxis: {
        type: 'category',
        data: category,
        show: false,
        axisLabel: {
            show: false,
        },
    },
    yAxis: {
        type: 'value',
        show: false,
        min: 'dataMin',
        max: 'dataMax',
        axisLabel: {
            show: false,
        },
    },
    series: [
        {
            name: seriesLabel,
            data: series,
            type: 'line',
            lineStyle: {
                color: "#CCCCCC"
            },
        }
    ]
};
`;